import qs from 'qs';

const query = qs.parse(window.location.search.substring(1));

export default query.i;
